import React, { useRef, useState, useEffect } from "react";

import { authServer } from "../api/axios";
import "./Login.css";
import SAMLogo from "../icons/SAM-integrity-logo.svg";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Card } from "@progress/kendo-react-layout";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { makeArray } from "../permissionUtils";
import { setAuthChange } from "../redux/toolSelectSlice";

const Login = () => {
    const dispatch = useDispatch();
    const mapConfig = useSelector((state) => state.configData.mapConfig);

    const navigate = useNavigate();
    const locaton = useLocation();
    const from = locaton.state?.from?.path || "/";

    const userRef = useRef();
    const errRef = useRef();

    const [userName, setUserName] = useState("");
    const [pwd, setPwd] = useState("");
    const [checkbox, setCheckbox] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errMsg, setErrMsg] = useState("");
    const [SiteName, setSiteName] = useState("");
    const [authChangeDone, setAuthChangeDone] = useState(false);

    useEffect(() => {
        const temp = window.localStorage.getItem("username");
        if (temp) {
            setUserName(temp);
            setCheckbox(true);
        } else {
            userRef.current.focus();
        }
    }, []);

    useEffect(() => {
        if (!mapConfig) {
            setSiteName("Loading");
        } else {
            setSiteName(`${mapConfig.DisplayName}`);
        }
    }, [mapConfig]);

    useEffect(() => {
        setErrMsg("");
    }, [userName, pwd]);

    useEffect(() => {
        if (authChangeDone) {
            dispatch(setAuthChange(true));
        }
    }, [authChangeDone]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (userName.length === 0 || pwd.length === 0) {
                setErrMsg("Invalid Username or Password");
            } else {
                const response = await authServer.post(
                    process.env.REACT_APP_AUTH_TOKEN_URL,
                    {
                        username: userName,
                        password: pwd,
                        client_id: `${process.env.REACT_APP_AUTH_SERVER_CLIENTID}`,
                        grant_type: "password",
                    }
                );
                const accessToken = response?.data?.access_token;
                const tokenRoles = jwt_decode(accessToken).realm_access.roles;
                const authedRoles = makeArray(mapConfig.Permissions).filter((i) =>
                    tokenRoles.includes(i.Value)
                );
                if (authedRoles.length === 0) {
                    throw new Error("Access Denied");
                } else {
                    if (checkbox) {
                        window.localStorage.setItem("username", userName);
                    } else {
                        window.localStorage.removeItem("username");
                    }
                    setUserName("");
                    setPwd("");
                    setLoading(false);
                    setAuthChangeDone(true);
                    setTimeout(() => {
                        navigate(from, { replace: true });
                    }, 500);
                }
            }
        } catch (error) {
            console.log(error);
            if (error?.name === "Error") {
                setErrMsg(error.message);
            } else if (!error?.response) {
                setErrMsg("No Server Response");
            } else if (error.response?.status === 401) {
                setErrMsg("Invalid Username or Password");
            } else if (error.response?.status === 500) {
                setErrMsg("Server Error. Please Try again");
            } else {
                setErrMsg("Login Attempt Failed");
            }
            setLoading(false);
            errRef.current.focus();
        }
    };

    return (
        <div className="content login">
            <img className="brand" src={SAMLogo} alt="SAM Logo"></img>
            <Card>
                <header>
                    <img src={process.env.REACT_APP_SAM_LOGO_URL} alt="SAM Logo" />
                    <h1>{SiteName}</h1>
                </header>
                <Form
                    onSubmit={handleSubmit}
                    render={() => (
                        <FormElement>
                            <h3>Login</h3>
                            <fieldset className={"k-form-fieldset"}>
                                <Input
                                    ref={userRef}
                                    name={"username"}
                                    component={Input}
                                    label={"Username"}
                                    type={"text"}
                                    onChange={(e) => setUserName(e.target.value)}
                                    value={userName}
                                    disabled={loading}
                                />
                                <Field
                                    name={"password"}
                                    component={Input}
                                    label={"Password"}
                                    type={"password"}
                                    value={pwd}
                                    onChange={(e) => setPwd(e.target.value)}
                                    required
                                    disabled={loading}
                                />
                                <span className={"k-form-separator"} />
                                <Checkbox
                                    id={"rememberme"}
                                    name={"rememberme"}
                                    label={"Remember Me"}
                                    value={checkbox}
                                    onChange={(e) => {
                                        setCheckbox(e.target.value);
                                    }}
                                    component={Checkbox}
                                    disabled={loading}
                                />
                            </fieldset>
                            {
                                <span
                                    ref={errRef}
                                    className={
                                        errMsg ? "login error" : "login errorhidden"
                                    }>
                                    {errMsg}
                                </span>
                            }
                            <div className="k-form-buttons">
                                <Button
                                    type={"submit"}
                                    disabled={loading}
                                    onClick={handleSubmit}>
                                    Login
                                </Button>
                            </div>
                            <br />
                            <a href="/forgotpassword">Forgot Password</a>
                            {/*REPLACE WITH REACT ROUTER Route */}
                        </FormElement>
                    )}
                />
            </Card>
        </div>
    );
};

export default Login;
